import React, { useState } from 'react'
import { EscalationPolicyService } from 'utility'
import {
    formatWatcherMeta,
    getApiErrorMessage,
    getWatcherInitials,
} from 'page-components/escalation-policy/utils'
import { AddWatcherModal } from './AddWatcherModal'
import {
    WatcherList,
    WatcherRow,
    WatcherAvatar,
    WatcherInfo,
    WatcherName,
    WatcherMeta,
    NotifyFlags,
    NotifyFlag,
    WatcherRemove,
    Btn,
} from './styles'

export const WatchersPanel = ({
    ticketId,
    watchers,
    onChanged,
    canEdit = true,
}) => {
    const [open, setOpen] = useState(false)
    const [removingId, setRemovingId] = useState(null)
    const [error, setError] = useState('')

    const handleRemove = async watcherId => {
        setRemovingId(watcherId)
        setError('')
        try {
            await EscalationPolicyService.removeTicketWatcher(
                ticketId,
                watcherId,
            )
            onChanged?.()
        } catch (err) {
            setError(getApiErrorMessage(err))
        } finally {
            setRemovingId(null)
        }
    }

    return (
        <>
            {error && (
                <div style={{ color: '#b91c1c', fontSize: 12, marginBottom: 8 }}>
                    {error}
                </div>
            )}
            {watchers.length === 0 && (
                <div style={{ color: '#64748b', fontSize: 13 }}>
                    No watchers yet.
                </div>
            )}
            <WatcherList>
                {watchers.map((watcher, index) => (
                    <WatcherRow key={watcher.watcherId}>
                        <WatcherAvatar $index={index} $external={watcher.isExternal}>
                            {getWatcherInitials(watcher)}
                        </WatcherAvatar>
                        <WatcherInfo>
                            <WatcherName>
                                {watcher.name || watcher.email || 'Watcher'}
                            </WatcherName>
                            <WatcherMeta>{formatWatcherMeta(watcher)}</WatcherMeta>
                            <NotifyFlags>
                                {watcher.notifyOnEscalated && (
                                    <NotifyFlag $kind="escalated">
                                        Escalated
                                    </NotifyFlag>
                                )}
                                {watcher.notifyOnUpdated && (
                                    <NotifyFlag>Updated</NotifyFlag>
                                )}
                                {watcher.notifyOnResolved && (
                                    <NotifyFlag>Resolved</NotifyFlag>
                                )}
                                {watcher.notifyOnCreated && (
                                    <NotifyFlag>Created</NotifyFlag>
                                )}
                            </NotifyFlags>
                        </WatcherInfo>
                        {canEdit && (
                            <WatcherRemove
                                type="button"
                                title="Remove watcher"
                                disabled={removingId === watcher.watcherId}
                                onClick={() => handleRemove(watcher.watcherId)}
                            >
                                ✕
                            </WatcherRemove>
                        )}
                    </WatcherRow>
                ))}
            </WatcherList>
            {canEdit && (
                <Btn
                    type="button"
                    style={{ marginTop: 12, width: '100%', justifyContent: 'center' }}
                    onClick={() => setOpen(true)}
                >
                    + Add watcher
                </Btn>
            )}
            <AddWatcherModal
                open={open}
                onClose={() => setOpen(false)}
                ticketId={ticketId}
                onAdded={onChanged}
            />
        </>
    )
}
